export default defineNuxtPlugin(() => {
  const { public: { baseURL } } = useRuntimeConfig();
  const sellebrate = $fetch.create({
    baseURL,
    retry: 1,
    credentials: 'include',
    retryStatusCodes: [401],
    onResponseError: async ({ request, options, response }) => {
      const status = response?.status;

      // Attempt token refresh on unauthorized
      if (status === 401) {
        const { refresh } = useAuthStore();
        await refresh();
        return;
      }

      // Handle forbidden globally on protected requests
      if (status === 403) {
        // Determine request URL to optionally skip login endpoint
        const reqUrl = typeof request === 'string'
          ? request
          : (request as any)?.url || '';

        const isLoginRequest = reqUrl.includes('/users/login') && (options?.method || '').toUpperCase() === 'POST';

        const detail = (response as any)?._data?.detail;
        const code = typeof detail === 'object' ? detail?.code : undefined;

        if (!isLoginRequest && code === 'ACCOUNT_INACTIVE') {
          const { add: addSnackbar } = useSnackbar();
          addSnackbar({
            autoClose: false,
            variant: 'error',
            title: 'This account has been disabled. Please contact support.',
          });

          // Send user to login screen (same behavior as 401)
          const { logout } = useAuthStore();
          await logout();
        }
      }
    },
  });

  return {
    provide: {
      sellebrate,
    },
  };
});
